import { render, staticRenderFns } from "./successRegister.vue?vue&type=template&id=3ecf56e1"
import script from "./successRegister.vue?vue&type=script&lang=js"
export * from "./successRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports